'use strict';

angular.module('programme')

.directive('playerList', function ()
{
    return {
        restrict: 'AE',
        replace: true,
        templateUrl: 'modules/programme/editor-components/player-list/player-list.html',
        controller: 'PlayerListCtrl',
        controllerAs: '$ctrl',
    };
})

.controller('PlayerListCtrl', function ($scope, ListController)
{
    this.$onInit = function ()
    {
        if (!$scope.model.list) {
            $scope.model.list = this.createPlayers(12);
        }
    };

    this.defaultPlayer = {
        name: 'Name',
        dob: 'dd/mm/yyyy',
        nationality: 'Nationality',
        position: 'Position',
        description: 'Description',
    };

    $scope.$list = new ListController($scope.model.list, {
        defaultItem: this.defaultPlayer,
    });


    this.createPlayers = function (count)
    {
        var list = [];
        for (var i = 0; i < count; i++) {
            list.push(angular.copy(this.defaultPlayer));
        }

        return list;
    };
});
